import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {changeProductionStatusV3} from "../../../services/api/apiNextBarcode"
import Button from "reactstrap/es/Button"
import Promise from 'bluebird'
import {pushNewItemHistory} from "../../../services/api/apiItemHistory";
import className from "classnames";

class BulkChangeStatusModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            status: '',
            customerChange: '',
            note: '',
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: '',
            validated: false
        }
    }

    componentDidMount = async () => {
        await this._genListItems()
    }

    _genAllItems = () => {
        const {listItems} = this.state

        this._bukdChangeStatus(listItems)
    }

    _handleChangeStatus = (e) => {
        const {value} = e.target

        this.setState({
            status: value
        })
    }

    _handleChange = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _genListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _bukdChangeStatus = async (listItems) => {
        const {status} = this.state

        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        status !== '' && (
            await Promise.each(listItems, async item => {
                this.setState({
                    itemLoading: item._id
                })

                try {
                    const {production_status} = item
                    const {success, message} = await changeProductionStatusV3(item._id, status)
                    let {itemError, itemsSuccess, customerChange, note} = this.state

                    if(success) {

                        itemsSuccess.push(item._id)

                        this.setState({
                            itemsSuccess: itemsSuccess,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        }, () => {
                            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                                event_key: 'change_status',
                                event_description: `Change status on bulk actions`,
                                user_created: customerChange,
                                note: note,
                                event_meta: {
                                    from: production_status,
                                    to: status
                                }
                            })
                        })


                    } else {
                        itemError.push({
                            _id: item._id,
                            message: message
                        })

                        this.setState({
                            itemError: itemError,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        })
                    }
                } catch (e) {
                    let {itemError, itemsSuccess} = this.state

                    this.setState({
                        itemError: e.message,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }

            })
        )
    }

    _changeItemStatus = async (item) => {
        const {status} = this.state

        try {
            const {production_status} = item
            const {itemsSuccess, itemError, customerChange, note} = this.state
            const {success, message} = await changeProductionStatusV3(item._id, status)

            if(success) {
                itemsSuccess.push(item._id)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                }, () => {
                    return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                        event_key: 'change_status',
                        event_description: `Change status on bulk actions`,
                        user_created: customerChange,
                        note: note,
                        event_meta: {
                            from: production_status,
                            to: status
                        }
                    })
                })
            } else {
                const newItemErr = itemError.map(item2 => {
                    if(item2._id === item._id) {
                        return {
                            ...item2,
                            message: message
                        }
                    }
                    return item2
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        const {status} = this.state

        this.setState({
            validated: true
        })

        if (this.state.customerChange === '' || this.state.note === '') return false

        const r = window.confirm(`Bạn có chắc chắn muốn thay đổi trạng thái thành ${status}?`)

        if (r !== true) {
            this.setState({
                status: '',
                customerChange: '',
                note: '',
                validated: false
            })
            return
        }

        this._genAllItems()
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(item2 => {
            if(item2._id === item._id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: item._id
        })

        this._changeItemStatus(item)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._bukdChangeStatus(itemError)
    }

    _showMessage = (itemError, itemsSuccess, _id) => {
        if(itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if(itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if(itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Order change status success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    _genIcon = (item) => {
        const {itemsSuccess, itemError} = this.state

        if(itemsSuccess.includes(item._id)) return <i className="icon-check text-success"/>

        if(itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) return <i className="icon-cross text-danger"/>

        return <i className="icon-spinner6 text-dark"/>
    }

    render() {
        const {isOpen, handleToggleModal, roles} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError, status, customerChange, note, validated} = this.state

        return (
            <div>
                <Modal isOpen={isOpen} className="BulkChangeStatus"
                >
                    <ModalHeader>
                        Cập nhật trạng thái
                    </ModalHeader>
                    <ModalBody>
                        <div className="selectStatus mb-3 row">
                            <label className="col-sm-3 col-form-label">Trạng thái</label>
                            <div className="col-sm-9">
                                {
                                    roles.indexOf('fac_ffm') >= 0 || roles.indexOf('fac_admin') >= 0 ? <select value={status} className="form-control" disabled={itemLoading !== ''} onChange={this._handleChangeStatus}>
                                        <option value="">Trạng thái</option>
                                        <option value="pending">Pending</option>
                                        <option value="on-hold">On Hold</option>
                                        <option value="cancelled">Cancel</option>
                                        <option value="cancel-ship">Cancel ship</option>
                                        <option value="manual-package">Manual packaged</option>
                                    </select> : <select value={status} className="form-control" disabled={itemLoading !== ''} onChange={this._handleChangeStatus}>
                                        <option value="">Trạng thái</option>
                                        <option value="pending">Pending</option>
                                        <option value="on-hold">On Hold</option>
                                        <option value="manual-package">Manual packaged</option>
                                    </select>
                                }
                            </div>
                        </div>
                        {(status !== '') && (
                            <div>
                                <div className="customerChange mb-3 row">
                                    <label className="col-sm-3 col-form-label">Người thực hiện</label>
                                    <div className="col-sm-9">
                                        <input className={className('form-control', (customerChange === '' && validated) && 'border-danger')} name="customerChange" onChange={this._handleChange}/>
                                        {(customerChange === '' && validated) && (
                                            <div className="text-danger mt-1">Vui lòng nhập người thực hiện </div>
                                        )}
                                    </div>
                                </div>
                                <div className="customerChange mb-3 row">
                                    <label className="col-sm-3 col-form-label">Lý do</label>
                                    <div className="col-sm-9">
                                        <input className={className('form-control', (note === '' && validated) && 'border-danger')} name="note" onChange={this._handleChange}/>
                                        {(note === '' && validated) && (
                                            <div className="text-danger mt-1">Vui lòng nhập lý do</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        {listItems.length > 0 && (
                            <div className="ListChangeStatus">
                                {
                                    listItems.map(item => {
                                        return (
                                            <div key={item._id} className="ItemChangeStatus d-sm-flex mb-2 pb-2">
                                                <div className="IconStatus mr-2">
                                                    {this._genIcon(item)}
                                                </div>
                                                <div className="ContentChangeStatus">
                                                    <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                    {
                                                        (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                            <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                        )
                                                    }
                                                    {itemLoading === item._id && <i className='icon-spinner2 spinner ml-2'/>}
                                                    {this._showMessage(itemError, itemsSuccess, item._id)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            {itemError.length > 0 && (
                                <Button onClick={this._retryAll} className="bg-danger"><i className="icon-spinner11 mr-1"/>Cập nhật lại </Button>
                            )}
                            <Button disabled={itemLoading !== ''} onClick={handleToggleModal} className="bg-grey ml-2">
                                Đóng
                            </Button>
                            <Button disabled={itemLoading !== '' || !status} onClick={this._handleSubmit} className="bg-primary ml-2">
                                Cập nhật trạng thái
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default BulkChangeStatusModal